import {LOAD_PARAMETROS_SUCCESS, IParametro, ParametroActionTypes} from "../types/parametroActionTypes";


export default function parametroReducer(state = [], action: ParametroActionTypes): IParametro[] {
    switch (action.type) {
        case LOAD_PARAMETROS_SUCCESS:
            return action.parametros;
        default:
            return state;
    }
}

